
import { useBadgeAward as useNewBadgeAward } from './badges/useBadgeAward';

export const useBadgeAward = useNewBadgeAward;
